import {Line} from 'vue-chartjs'

export default {
	extends: Line,
	props: {
		data: Array
	},
	mounted () {

		const {data} = this;

		const arraySize = data.length;

		this.addPlugin({
			id: 'my-plugin2333',
			afterDatasetsDraw: function (chart) {
				const {ctx} = chart;
				const {data} = chart.getDatasetMeta(0);
				const offsetIndex = 3;
				const length = data.length;
				const index = length > offsetIndex ? length - offsetIndex : 0;
				const scaleY = chart.scales['y-axis-0'];

				const {x, y} = data[index]._model;

				const lineX = x - 0.5;
				const horizontalLinesWidth = 6;

				ctx.save();
				ctx.strokeStyle = "rgba(255, 255, 255, 0.6)";
				ctx.lineWidth = 1;
				ctx.beginPath();
				ctx.moveTo(lineX, 4);
				ctx.lineTo(lineX, scaleY.bottom);
				ctx.stroke();

				ctx.strokeStyle = "rgba(255, 255, 255, 1)";
				ctx.beginPath();
				ctx.lineWidth = 2;
				ctx.moveTo(lineX - horizontalLinesWidth / 2, y);
				ctx.lineTo(lineX + horizontalLinesWidth / 2, y);
				ctx.stroke();

				ctx.restore();
			}
		});

		this.renderChart({
			labels: Array.from(new Array(arraySize).keys()).map(v => `${v}`),
			datasets: [{
				radius: 0,
				fill: false,
				borderWidth: 1,
				borderColor: 'rgba(255, 255, 255, .7)',
				borderJoinStyle: 'miter',
				borderCapStyle: 'butt',
				data,
			}]
		}, {
			layout: {
				padding: {
					left: 5,
					right: 20,
					top: 4,
					bottom: 4
				}
			},
			responsive: true,
			maintainAspectRatio: false,
			scales: {
				xAxes: [{
					display: false
				}],
				yAxes: [{
					display: false
				}]
			},
			legend: {
				display: false
			},
			tooltips: {
				enabled: false
			}
		});
	}
}
